var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C7.96833 1.50807e-08 8.8788 0.183281 9.73047 0.550781C10.582 0.918272 11.3222 1.41791 11.9521 2.04785C12.5821 2.6778 13.0817 3.41796 13.4492 4.26953C13.8167 5.1212 14 6.03167 14 7C14 7.96833 13.8167 8.8788 13.4492 9.73047C13.0817 10.582 12.5821 11.3222 11.9521 11.9521C11.3222 12.5821 10.582 13.0817 9.73047 13.4492C8.8788 13.8167 7.96833 14 7 14C6.03167 14 5.1212 13.8167 4.26953 13.4492C3.41796 13.0817 2.6778 12.5821 2.04785 11.9521C1.41791 11.3222 0.918272 10.582 0.550781 9.73047C0.183281 8.8788 1.50809e-08 7.96833 0 7C0 6.03167 0.183281 5.1212 0.550781 4.26953C0.918272 3.41796 1.41791 2.6778 2.04785 2.04785C2.6778 1.41791 3.41796 0.918272 4.26953 0.550781C5.1212 0.183281 6.03167 0 7 0ZM7 1.40039C5.43667 1.40039 4.11234 1.94234 3.02734 3.02734C1.94234 4.11234 1.40039 5.43667 1.40039 7C1.40039 8.56333 1.94234 9.88766 3.02734 10.9727C4.11234 12.0577 5.43667 12.5996 7 12.5996C8.56333 12.5996 9.88766 12.0577 10.9727 10.9727C12.0577 9.88766 12.5996 8.56333 12.5996 7C12.5996 5.43667 12.0577 4.11234 10.9727 3.02734C9.88766 1.94234 8.56333 1.40039 7 1.40039ZM11.1992 7.69922H2.7998V6.2998H11.1992V7.69922Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSubtract);
export default __webpack_public_path__ + "static/media/icons_subtract.2491a1f7.svg";
export { ForwardRef as ReactComponent };